import React from "react";
import {useTranslation} from "react-i18next";

import gif from "./6E6.gif";
const DeployBoundary = () => {
  const {t} = useTranslation();

  return (
    <div className="flex_container jcc aic" style={{flexDirection: "column", width: "100%", height: "100%"}}>
      <img src={gif} alt="Анимация" width="250" height="250" />
      <p> {t("maintenance")}</p>
    </div>
  );
};

export default DeployBoundary;
